/* TruckParts Pro — vanilla JS. Cart drawer, mobile nav, gallery, variants, steppers. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function money(cents) {
    try { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- cart state ---------- */
  function openCart() { document.body.classList.add('cart-open'); var d = $('[data-cart-drawer]'); if (d) d.setAttribute('aria-hidden', 'false'); }
  function closeCart() { document.body.classList.remove('cart-open'); var d = $('[data-cart-drawer]'); if (d) d.setAttribute('aria-hidden', 'true'); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var wrap = $('[data-cart-items]');
    var foot = $('[data-cart-foot]');
    if (!wrap) return;
    if (!cart.items || cart.items.length === 0) {
      wrap.innerHTML = '<div class="cart-drawer__empty"><p>' + escapeHtml(cartEmptyMsg()) + '</p>' +
        '<a class="btn btn--solid" href="/collections/best-sellers">Shop best sellers</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    wrap.innerHTML = cart.items.map(function (item) {
      var url = escapeHtml(item.url || '#');
      var img = item.image ? '<a href="' + url + '" class="drawer-line__imglink" tabindex="-1" aria-hidden="true"><img class="drawer-line__img" src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') + '" alt="" loading="lazy"></a>' : '';
      return '<div class="drawer-line">' + img +
        '<div><p class="drawer-line__title"><a href="' + url + '">' + escapeHtml(item.product_title) + '</a></p>' +
        (item.variant_title ? '<p class="drawer-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
        '<div class="drawer-line__row"><div class="qty" data-qty>' +
        '<button type="button" class="qty__btn" data-drawer-dec="' + item.key + '" aria-label="Decrease quantity">' + minusSvg() + '</button>' +
        '<input class="qty__input" type="number" value="' + item.quantity + '" min="0" data-drawer-qty="' + item.key + '" aria-label="Quantity">' +
        '<button type="button" class="qty__btn" data-drawer-inc="' + item.key + '" aria-label="Increase quantity">' + plusSvg() + '</button></div>' +
        '<span class="drawer-line__price">' + money(item.final_line_price) + '</span></div>' +
        '<button type="button" class="drawer-remove" data-drawer-remove="' + item.key + '">' + escapeHtml(removeMsg()) + '</button></div></div>';
    }).join('');
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    if (foot) foot.hidden = false;
  }

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function minusSvg() { return '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>'; }
  function plusSvg() { return '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>'; }
  function cartEmptyMsg() { var el = $('[data-cart-drawer]'); return (el && el.getAttribute('data-empty-msg')) || 'Your cart is empty.'; }
  function removeMsg() { return 'Remove'; }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); }).catch(function () {});
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); refreshCart().then(openCart); return; }
    if ((t = e.target.closest('[data-cart-close]'))) { closeCart(); return; }
    if ((t = e.target.closest('[data-nav-open]'))) {
      var nav = $('[data-mobile-nav]');
      if (nav) { nav.classList.add('open'); nav.setAttribute('aria-hidden', 'false'); t.setAttribute('aria-expanded', 'true'); }
      return;
    }
    if ((t = e.target.closest('[data-nav-close]'))) {
      var nav2 = $('[data-mobile-nav]');
      if (nav2) { nav2.classList.remove('open'); nav2.setAttribute('aria-hidden', 'true'); }
      var tog = $('[data-nav-open]'); if (tog) tog.setAttribute('aria-expanded', 'false');
      return;
    }
    if ((t = e.target.closest('[data-drawer-inc]'))) { changeQty(t.getAttribute('data-drawer-inc'), parseInt(t.parentElement.querySelector('input').value, 10) + 1 || 1); return; }
    if ((t = e.target.closest('[data-drawer-dec]'))) { changeQty(t.getAttribute('data-drawer-dec'), Math.max(0, parseInt(t.parentElement.querySelector('input').value, 10) - 1 || 0)); return; }
    if ((t = e.target.closest('[data-drawer-remove]'))) { changeQty(t.getAttribute('data-drawer-remove'), 0); return; }
    if ((t = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      var id = t.getAttribute('data-quick-add');
      t.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      }).then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () {})
        .then(function () { t.removeAttribute('aria-busy'); });
      return;
    }
    if ((t = e.target.closest('[data-qty-minus]'))) {
      var inp = t.parentElement.querySelector('[data-qty-input]');
      if (inp) inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1);
      return;
    }
    if ((t = e.target.closest('[data-qty-plus]'))) {
      var inp2 = t.parentElement.querySelector('[data-qty-input]');
      if (inp2) inp2.value = (parseInt(inp2.value, 10) || 1) + 1;
      return;
    }
    var thumb = e.target.closest('.pd-thumb');
    if (thumb) {
      var thumbs = $$('.pd-thumb');
      var idx = thumbs.indexOf(thumb);
      var track = $('[data-gallery-track]');
      if (track && idx > -1) track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      return;
    }
  });

  /* ---------- gallery: swipe syncs active thumbnail ---------- */
  (function () {
    var track = $('[data-gallery-track]');
    if (!track) return;
    var timer = null;
    function setActive(i) {
      var thumbs = $$('.pd-thumb');
      thumbs.forEach(function (b, j) { b.classList.toggle('pd-thumb--active', j === i); });
      var a = thumbs[i];
      if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, i));
      }, 90);
    }, { passive: true });
  })();

  /* ---------- gallery: preload full images so switching is instant ---------- */
  function preloadGallery() {
    $$('.pd-thumb[data-full]').forEach(function (t) {
      var im = new Image();
      im.src = t.getAttribute('data-full');
    });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(preloadGallery, { timeout: 2500 });
  else if (document.readyState === 'complete') preloadGallery();
  else window.addEventListener('load', preloadGallery);

  document.addEventListener('change', function (e) {
    var t;
    if ((t = e.target.closest('[data-drawer-qty]'))) {
      changeQty(t.getAttribute('data-drawer-qty'), Math.max(0, parseInt(t.value, 10) || 0));
      return;
    }
    if ((t = e.target.closest('[data-sort]'))) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', t.value);
      window.location.href = url.toString();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); var nav = $('[data-mobile-nav]'); if (nav) nav.classList.remove('open'); }
  });

  /* ---------- product form: AJAX add + variant switching ---------- */
  $$('[data-product-form]').forEach(function (form) {
    var dataEl = document.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }
    var idInput = form.querySelector('[data-variant-id]');
    var priceCurrent = document.querySelector('[data-price-current]');

    /* disable sold-out option pills (strikethrough) */
    (function markSoldOut() {
      $$('.pd-pills', form).forEach(function (group) {
        var radios = $$('input[type="radio"]', group);
        radios.forEach(function (r) {
          var ok = false;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if ((v.option1 === r.value || v.option2 === r.value || v.option3 === r.value) && v.available) { ok = true; break; }
          }
          if (!ok) {
            r.disabled = true;
            var lab = r.closest('.pill');
            if (lab) lab.classList.add('pill--soldout');
          }
        });
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked && checked.disabled) {
          var alt = group.querySelector('input[type="radio"]:not(:disabled)');
          if (alt) {
            alt.checked = true;
            var ev = document.createEvent('HTMLEvents');
            ev.initEvent('change', true, false);
            alt.dispatchEvent(ev);
          }
        }
      });
    })();

    function currentOptions() {
      var opts = {};
      $$('input[type="radio"]:checked', form).forEach(function (r) {
        var name = r.name.replace(/^options\[/, '').replace(/\]$/, '');
        opts[name] = r.value;
      });
      return opts;
    }
    function findVariant() {
      var opts = currentOptions();
      var vals = Object.keys(opts).map(function (key) { return opts[key]; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var k = 0; k < vals.length; k++) {
          if (v['option' + (k + 1)] !== vals[k]) { match = false; break; }
        }
        if (match) return v;
      }
      return variants[0];
    }
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var pc = form.querySelector('[data-price-current]') || document.querySelector('[data-price-current]');
      if (pc) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="p-card__compare">' + money(v.compare_at_price) + '</s>';
        html += '<span class="pd-price__current" data-price-current>' + money(v.price) + '</span>';
        var wrap = pc.closest('[data-price]');
        if (wrap) wrap.innerHTML = html; else pc.innerHTML = html;
      }
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add-label') || btn.textContent : btn.getAttribute('data-sold-label') || 'Sold out';
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
    });
  });

  /* ---------- cart page steppers ---------- */
  document.addEventListener('click', function (e) {
    var t;
    function postUpdate(updates) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.reload(); }).catch(function () {});
    }
    if ((t = e.target.closest('[data-cart-inc]'))) { postUpdate((function (o) { o[t.getAttribute('data-cart-inc')] = (parseInt(t.parentElement.querySelector('input').value, 10) || 0) + 1; return o; })({})); }
    else if ((t = e.target.closest('[data-cart-dec]'))) { postUpdate((function (o) { o[t.getAttribute('data-cart-dec')] = Math.max(0, (parseInt(t.parentElement.querySelector('input').value, 10) || 0) - 1); return o; })({})); }
    else if ((t = e.target.closest('[data-cart-remove]'))) { postUpdate((function (o) { o[t.getAttribute('data-cart-remove')] = 0; return o; })({})); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-cart-qty]');
    if (t) {
      var o = {}; o[t.getAttribute('data-cart-qty')] = Math.max(0, parseInt(t.value, 10) || 0);
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: o }) })
        .then(function () { window.location.reload(); }).catch(function () {});
    }
  });

  /* ---------- init ---------- */
  refreshCart();
})();

  /* ---------- gallery: show fewer / show all thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-thumbs-toggle]');
    if (!btn) return;
    var wrap = btn.parentElement.querySelector('.pd-thumbs');
    if (!wrap) return;
    var expanded = wrap.classList.toggle('pd-thumbs--expanded');
    btn.textContent = expanded ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
  });
